import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import ListeningStory from 'components/ListeningStory';

export const ListeningStoryModalComponent = ({ listeningResource, setupInfo }) => {
  return <ExtendedContentContainer extendedContentType={ExtendedContentType.Listening}>
    <ListeningStory data={listeningResource} defaultObj={setupInfo} />
  </ExtendedContentContainer>
};